import { useQuery } from '@tanstack/vue-query';

export function usePredefined() {
    const userStore = useUserStore();

    const { data, isLoading, isFetching, refetch, error } = useQuery({
        queryKey: computed(() => ['predefined', userStore.tenantId]),
        queryFn: getPredefined,
        // /orders/predefined is a tenant-only endpoint (admin-tenant:false), so it
        // 403s in the central (movepro admin) context — which the global axios
        // interceptor turns into a 403Page redirect. Only fetch for a real tenant;
        // the queryKey carries tenantId, so switching back to a tenant re-enables it.
        enabled: computed(() => Boolean(userStore.tenantId) && userStore.isTenantContext),
        retry: false,
        staleTime: 1000 * 60 * 60 * 24, // 24 hours before its considered stale
        gcTime: 1000 * 60 * 60 * 24, // 24 hours before the query is garbage collected
    });

    async function getPredefined() {
        const response = await window.tenantAxios.get('/orders/predefined');
        return response.data.predefined;
    }

    const accessTags = computed(() => data.value?.access_tags);
    const moveDateIntervals = computed(() => data.value?.move_date_intervals);
    const dwellingTypes = computed(() => data.value?.residential_property_types);
    const deliveryDateFlexibility = computed(() => data.value?.delivery_date_flexibility);
    const businessTypes = computed(() => data.value?.business_types);
    const moveCategories = computed(() => data.value?.move_categories);

    return {
        data,
        isLoading,
        isFetching,
        refetch,
        error,

        accessTags,
        moveDateIntervals,
        dwellingTypes,
        deliveryDateFlexibility,
        businessTypes,
        moveCategories,
    };
}
